import type { InvoiceStatus } from "@/features/invoices/types";

export const INV_STATUSES: { value: InvoiceStatus; label: string }[] = [
  { value: "draft", label: "Draft" },
  { value: "issued", label: "Issued" },
  { value: "cancelled", label: "Cancelled" },
];

export function labelFor(
  options: { value: string; label: string }[],
  value: string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function statusTone(status: InvoiceStatus): "success" | "warning" | "danger" | "neutral" {
  switch (status) {
    case "issued":
      return "success";
    case "cancelled":
      return "danger";
    default:
      return "neutral";
  }
}

export function canEditLines(status: InvoiceStatus) {
  return status === "draft";
}

export function canEditHeader(status: InvoiceStatus) {
  return status === "draft";
}
